<template>
  <span>
    <v-app-bar
      color="white"
      fixed
      style="border-radius: 0;">
      <v-toolbar-title>
        <v-btn
          to="/"
          text
          color="secondary"
          height="40px">
          <img
            src="logo_newmat.svg"
            alt="Plafond et mur tendus NEWMAT Annecy"
            height="30px">
        </v-btn>
      </v-toolbar-title>

      <v-spacer/>

      <v-toolbar-items class="menunav">
        <v-btn
          to="/#services"
          text
          color="secondary">Expertise</v-btn>
        <v-btn
          to="/#realisations"
          text
          color="secondary">Réalisations</v-btn>
        <v-btn
          to="/#technologie"
          text
          color="secondary">Technologie</v-btn>
        <v-btn
          to="/#devis"
          text
          color="secondary">Devis</v-btn>
        <v-btn
          to="/#contact"
          text
          color="secondary">Contact</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <section
      id="services">
      <v-parallax
        src="fond7_noblur.jpg"
        top
        height="380"
        class="gradienthero">
        <v-overlay
          :absolute="true"
          :value="true"
        >
          <v-layout
            column
            align-center
            justify-center>
            <div class="display-2 font-weight-bold white--text mb-4 text-center text-uppercase">Aspect</div>
            Aspects et couleurs plafonds tendus
          </v-layout>
        </v-overlay>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout
          wrap
          justify-center
          class="my-12">
          <v-flex
            xs12
            sm12>
            <v-card-text>
              <v-table>
                <tbody>
                  <tr>
                    <td
                      width="250"
                      align="center"
                      valign="middle"
                      class="font-weight-bold">
                      <a
                        href="http://newmat.com/"
                        target="_blank">Aspects
                        et couleurs </a>
                      <a href="https://newmatworld.com/headquarters/wp-content/uploads/2016/12/Newmat-Membranes-Catalogue.pdf">des
                      plafonds-tendus</a></td>
                    <td
                      width="250"
                      align="center"
                      valign="middle"
                      class="font-weight-bold"><a href="aspect.htm">Tous
                      les catalogues</a></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p/>
                        <p><a
                          href="http://newmat.com/newclassic/"
                          target="_blank">Les
                          Mats, les Satins,</a></p>
                        <p><a
                          href="http://newmat.com/newclassic/"
                          target="_blank">Les
                          Laques, les Marbres,</a></p>
                        <p><a
                          href="http://newmat.com/newclassic/"
                          target="_blank">
                          Les Décors, les Bois,</a></p>
                        <p> <a
                          href="http://newmat.com/newclassic/"
                          target="_blank">Les
                          dains, les pailletés,</a></p>
                        <p><a
                          href="http://newmat.com/newclassic/"
                          target="_blank">
                          Game classic</a></p>
                    </div></td>

                    <td><div align="center">
                      <p><a
                        href="http://fr.calameo.com/read/00528582560b4d5677e75"
                        target="_blank">Consultez
                        le catalogue de la game classic</a></p>
                      <p><a
                        href="http://newmat.com/newclassic/"
                        target="_blank"><img
                          src="logo-newmat.gif"
                          alt="Mat-Satin-laque-Marbre"
                          width="128"
                          height="29"
                          border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td><div align="center">
                      <p/>
                      <p>Les plafonds tendus perforés
                      Newline</p>
                      <p><a
                        href="http://newmat.com/newperfo/"
                        target="_blank">Newperfo</a></p>
                      <p/>
                    </div></td>

                    <td><div align="center">
                      <p/>
                      <p><a
                        href="http://newmat.com/newperfo/"
                        target="_blank">Consultez
                        le catalogue de la game Newline</a></p>
                      <p><a
                        href="http://newmat.com/newperfo/"
                        target="_blank"><img
                          src="newline.gif"
                          alt="des ptit trous des gros trous"
                          width="63"
                          height="68"
                          border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td width="250"><div align="center">
                      <p/>
                      <p><a
                        href="http://newmat.com/newlight/"
                        target="_blank">Les
                        plafonds tendus lumineux Newlight translucide, la lumière
                        par les plafonds.</a></p>
                      <p><a
                        href="http://newmat.com/newlight/"
                        target="_blank">Newlight</a></p>
                      <p/>
                    </div></td>

                    <td width="250"><div align="center">
                      <p/>
                      <p><a
                        href="http://fr.calameo.com/read/005285825f11b5f2c9d07"
                        target="_blank">Consultez
                        le catalogue de la game Newlight</a></p>
                      <p><a
                        href="http://newmat.com/newlight/"
                        target="_blank"><img
                          src="newlight-tendu.gif"
                          alt="Translucide-lumière au dessus"
                          width="75"
                          height="75"
                          border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p>Personalisez votre plafond tendu, imprimez
                        une oeuvre d'art ou message publicitaire à vous de choisir!!</p>
                        <p><a
                          href="http://newmat.com/newgraphic/"
                          target="_blank">Newgrafic</a></p>
                    </div></td>

                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p/>
                        <p><a
                          href="http://fr.calameo.com/read/00528582502b234628d2e"
                          target="_blank">Consultez
                          le catalogue de la game Newgraphic</a></p>
                        <p><a
                          href="http://newmat.com/newgraphic/"
                          target="_blank"><img
                            src="newgraphic.gif"
                            alt="mon rêve imprimé"
                            width="70"
                            height="68"
                            border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p>Trop de bruit de résonance le
                        plafond tendu microperforé antibruit </p>
                        <p><a
                          href="http://newmat.com/newacoustic/"
                          target="_blank">Newacoustic</a></p>
                    </div></td>

                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p><a
                          href="http://fr.calameo.com/read/005285825e8586fe5448d"
                          target="_blank">Consultez
                          le catalogue de la game Newacoustic</a></p>
                        <p><a
                          href="http://newmat.com/newacoustic/"
                          target="_blank"><img
                            src="newacoustic.jpg"
                            alt="Le silence devient roi"
                            width="46"
                            height="68"
                            border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p/>
                        <p>Hopitaux, salle blanche, agro alimentaire,
                        traitement anti-fongicique et anti-microbien, Hygiène
                        parfaite</p>
                        <p><a
                          href="http://newmat.com/newbiopruf/"
                          target="_blank">Biopruf</a></p>
                        <p/>
                    </div></td>

                    <td><div align="center">
                      <p><a
                        href="http://fr.calameo.com/read/005285825e6a7d755957b"
                        target="_blank">Consultez
                        le catalogue de la game Biopruf</a></p>
                      <p><a
                        href="http://newmat.com/newbiopruf/"
                        target="_blank"><img
                          src="bio-pruf.gif"
                          alt="Hygiène iréprochable!!"
                          width="71"
                          height="70"
                          border="0"
                          align="middle"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><p align="center"/>
                      <p align="center">Le plafond suspendu en
                      dalle, de plafond tendu!! <a
                        href="http://newmat.com/newmirodal/"
                        target="_blank">MIR.O.DAL</a>
                        Retrouvez toute la game classic sur vos dalles </p>
                    <p align="center"/></td>

                    <td><div align="center">
                      <p><a
                        href="http://fr.calameo.com/read/0052858259cca568f7c14"
                        target="_blank">Consultez
                        le catalogue de la game Mirodal</a></p>
                      <p><a
                        href="http://newmat.com/newmirodal/"
                        target="_blank"><img
                          src="mirodal.gif"
                          alt="Suspendu en tendu"
                          width="88"
                          height="70"
                          border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p>Découvrez le décor personnalisé
                        et réalisez tout vos désirs avec nos Tissus imprimés
                        les plus créatif </p>
                        <p><a
                          href="http://newmat.com/newtextil/"
                          target="_blank">New/Textil</a></p>
                    </div></td>

                    <td
                      align="center"
                      valign="middle"> <p align="center"><a
                        href="http://newmat.com/newtextil/"
                        target="_blank">Consultez
                        le catalogue de la game Newtextil</a></p>
                      <div align="center">
                        <p><a
                          href="http://newmat.com/newtextil/"
                          target="_blank"><img
                            src="RTEmagicC_NEWCLIP.jpg"
                            width="130"
                            height="184"
                            border="0"></a></p>
                    </div></td>
                  </tr>
                  <tr>
                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p>Grande surface, en plafond ou cloison,
                        toiles <a
                          href="http://www.sergeferrari.com/"
                          target="_blank">Ferrari</a><a
                            href="http://www.ferrari-industry.com/#/accueil/"
                            target="_blank"/>assemblées par nos soins le plafond architectonique
                            au service de la créativité.</p>
                        <p><a
                          href="http://newmat.com/newmesh/"
                          target="_blank">New/Mesh</a></p>
                    </div></td>

                    <td
                      align="center"
                      valign="middle"><div align="center">
                        <p><a
                          href="http://newmat.com/newmesh/"
                          target="_blank">Consultez
                          le catalogue de la game New/Mesh</a></p>
                        <p><a
                          href="http://newmat.com/newmesh/"
                          target="_blank"><img
                            src="RTEmagicC_BATINEWLINE.jpg"
                            alt="batinewline yoile ferrari"
                            width="130"
                            height="184"
                            border="0"
                            align="middle"></a></p>
                    </div></td>
                  </tr>
              </tbody></v-table>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <v-footer color="black">
      <v-layout
        wrap
        align-center
        class="white--text text-center">
        <v-flex xs4>
          <a
            href="https://www.newmat.com"
            target="_blank">
            <img
              class="logofooter"
              src="logo_newmat_white_white_solo.svg"
              alt="NewMat Plafond Tendu">
          </a>
        </v-flex>
        <v-flex xs4>
          <a
            href="https://www.plafonds-tendus.fr"
            target="_blank"
            class="white--text font-weight-bold textfooter">
            www.plafonds-tendus.fr
          </a>
        </v-flex>
        <v-flex xs4>
          <a
            href="https://www.cma-74.fr"
            target="_blank">
            <img
              class="logofooter"
              src="logochambredesmetiers.png"
              alt="Chambre des métiers de Haute-Savoie">
          </a>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Entreprise
            <ul>
              <li>
                <a href="../entreprise.htm">Entreprise</a>
              </li>
              <li>
                <a href="../equipe.htm">Équipe</a>
              </li>
              <li>
                <a href="../partenaire.htm">Partenaires</a>
              </li>
              <li>
                <a href="../localisation.htm">Localisation</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Prestations
            <ul>
              <li>
                <a href="../prestations.htm">Prestations</a>
              </li>
              <li>
                <a href="../aspect.htm">Aspect</a>
              </li>
              <li>
                <a href="../technique.htm">Technique</a>
              </li>
              <li>
                <a href="../Garantie-qualité.htm">Garanties qualité</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Services
            <ul>
              <li>
                <a href="../service.htm">Services</a>
              </li>
              <li>
                <a href="../electricite-spot-luminnaire.htm">Électricité</a>
              </li>
              <li>
                <a href="../menuiserie-bois-pvc.htm">Menuiserie</a>
              </li>
              <li>
                <a href="../acces-au-plenum.htm">Accés à l’ancien plafond</a>
              </li>
              <li>
                <a href="../isolation-thermique-phonique.htm">Isolation thermique et phonique</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex
          class="align-self-start"
          xs3>
          <v-card-text class="white--text pt-0 footerlinks">
            Infos
            <ul>
              <li>
                <a href="../Processus fabrication.htm">Processus de fabrication</a>
              </li>
              <li>
                <a href="../nettoyage.htm">Nettoyage</a>
              </li>
              <li>
                <a href="../lisse-plafond-tendu.htm">Les lisses</a>
              </li>
              <li>
                <a href="../entretien-des-lisses.htm">Entretien des Lisses</a>
              </li>
            </ul>
          </v-card-text>
        </v-flex>
        <v-flex xs12>
          <div class="white--text textfooter">
            &copy;
            1995 - {{ datesite }} |
            Site web réalisé par <a
              class="white--text font-weight-bold"
              href="https://www.thecompagnie.eu"
              target="_blank">TheCompagnie</a> |
            <router-link
              to="/admin"
              class="white--text"
            >
              Accès administration
            </router-link>
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  computed: {
    datesite () {
      return moment(new Date()).format('YYYY')
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.logoparalax{
  @media screen and (max-width: 550px) {
    width: 70vw !important;
  }
  width: 50vw !important;
}
.pastillegarantie{
  position: absolute;
  top: -3em;
  left:-3em;
  width:70px;
  @media screen and (max-width: 550px) {
    top: -2em;
    left:-2em;
    width:50px;
  }
}
.menunav{
  .v-btn{
    @media screen and (max-width: 550px) {
      padding-left: 2px !important;
      padding-right: 2px !important;
    }
  }
  @media screen and (max-width: 550px) {
    font-size: 0.6em !important;
  }
}
</style>
